import type { SVGProps } from 'react';
const SvgFacebookSquare = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 22 22" {...props}>
    <path d="M19.643 0H2.357A2.357 2.357 0 0 0 0 2.357v17.286A2.357 2.357 0 0 0 2.357 22h6.74v-7.48H6.003V11h3.094V8.317c0-3.052 1.817-4.738 4.6-4.738 1.333 0 2.726.238 2.726.238v2.995h-1.535c-1.513 0-1.985.94-1.985 1.902V11h3.377l-.54 3.52h-2.837V22h6.74A2.357 2.357 0 0 0 22 19.643V2.357A2.357 2.357 0 0 0 19.643 0" />
  </svg>
);
export default SvgFacebookSquare;
